import './userComponents.less';

export { default as SignMethod } from './SignMethod';
export { default as Password } from './Password';
export { default as MethodType } from './MethodType';
export { IWantSignInStyled } from './styled';

export const prefix = 'bm-c-user-components';
